var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    { staticClass: "impersonation", on: { click: _vm.logoutImpersonation } },
    [_vm._v("END SESSION")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }